/* CW family cross-links (D4). Reads the verified map + the page's own variant table; resolves each
   destination to a real variant: exact Color+pack -> same Color, smallest available pack (labelled) -> omit.
   Destination without a Color option = labelled single-colour fallback; destination WITH a Color option
   that lacks the source colour = omit (no fuzzy matching). DOM built with textContent only. */
(function () {
  'use strict';
  var CW_XLINK_ANALYTICS = false; // kill-switch: stays false until a receiver + consent handling are verified
  var root = document.querySelector('[data-cw-xlink]');
  if (!root) return;
  var groupsEl = root.querySelector('[data-cw-groups]');
  var handle = root.getAttribute('data-handle');
  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-cw-variants]').textContent); } catch (e) { return collapse(); }
  var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var productCache = {};
  var mapPromise = null;
  var renderToken = 0;
  var seen = {};

  function collapse() { root.classList.add('is-empty'); root.classList.remove('is-ready'); }

  function getMap() {
    if (!mapPromise) mapPromise = fetch(root.getAttribute('data-map')).then(function (r) { if (!r.ok) throw new Error('map'); return r.json(); });
    return mapPromise;
  }
  function getProduct(h) {
    if (!productCache[h]) {
      productCache[h] = fetch(routeRoot + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw new Error('p'); return r.json(); });
    }
    return productCache[h];
  }

  // The variant picker lives in the main product section, not in this section.
  function mainSection() {
    var picker = document.querySelector('variant-radios, variant-selects');
    return picker ? picker.closest('section, .shopify-section') : null;
  }
  function currentVariant(urlFirst) {
    var id = null;
    var sec = mainSection();
    var input = sec ? sec.querySelector('form[id^="product-form"] input[name="id"]') : null;
    var q = new URLSearchParams(location.search).get('variant');
    if (urlFirst && q) id = Number(q); // back/forward: the URL is the source of truth
    if (!id && input && input.value) id = Number(input.value);
    if (!id && q) id = Number(q);
    var v = variants.filter(function (x) { return x.id === id; })[0];
    return v || variants.filter(function (x) { return x.available; })[0] || variants[0];
  }

  function resolve(dest, colour, pack) {
    // /products/<h>.js returns options as objects ({name, position, values}) on current Shopify; accept strings too
    var names = (dest.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var ci = names.indexOf('Color');
    var pi = names.indexOf('Pieces');
    if (pi < 0) pi = names.indexOf('Size');
    var vs = dest.variants.filter(function (v) { return v.available; });
    if (!vs.length) return null;
    var note = '';
    if (colour && ci >= 0) {
      vs = vs.filter(function (v) { return v.options[ci] === colour; });
      if (!vs.length) return null;
    } else if (colour && ci < 0) {
      note = 'Single colour';
    } else if (!colour && ci >= 0) {
      return null;
    }
    var exact = pi < 0 ? vs[0] : vs.filter(function (v) { return v.options[pi] === pack; })[0];
    var chosen = exact;
    if (!chosen) {
      chosen = vs.slice().sort(function (a, b) { return Number(a.options[pi]) - Number(b.options[pi]); })[0];
      note = (note ? note + ' · ' : '') + chosen.options[pi] + '-pack';
    }
    var img = (chosen.featured_image && chosen.featured_image.src) || dest.featured_image || '';
    if (img) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=400';
    return { variant: chosen, colour: ci >= 0 ? chosen.options[ci] : null, note: note, img: img };
  }

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  function card(entry, r, module) {
    var li = el('li');
    var a = el('a', 'cw-xlink__card');
    a.href = routeRoot + 'products/' + encodeURIComponent(entry.handle) + '?variant=' + r.variant.id;
    a.setAttribute('data-cw-module', module);
    a.setAttribute('data-cw-dest', entry.handle);
    var box = el('div', 'cw-xlink__img');
    if (r.img) { var im = el('img'); im.src = r.img; im.alt = ''; im.loading = 'lazy'; im.width = 400; im.height = 400; box.appendChild(im); }
    a.appendChild(box);
    var t = el('div', 'cw-xlink__text');
    var colourPart = r.colour ? ' · ' + r.colour : '';
    if (module === 'A') {
      t.appendChild(el('span', 'cw-xlink__dir', entry.dir === 'smaller' ? '◂ Smaller' : 'Larger ▸'));
      t.appendChild(el('strong', null, entry.dims));
      t.appendChild(document.createElement('br'));
      t.appendChild(document.createTextNode(entry.label + colourPart));
    } else {
      t.appendChild(el('strong', null, entry.label + colourPart));
      t.appendChild(document.createElement('br'));
      t.appendChild(document.createTextNode(entry.dims));
    }
    if (r.note) t.appendChild(el('span', 'cw-xlink__note', r.note));
    a.appendChild(t);
    a.addEventListener('click', function () { emit('cw_crosslink_click', { module: module, source: handle, dest: entry.handle }); });
    li.appendChild(a);
    return li;
  }

  function group(title, items) {
    var g = el('div', 'cw-xlink__group');
    g.appendChild(el('h2', 'cw-xlink__title', title));
    var ul = el('ul', 'cw-xlink__cards');
    items.forEach(function (i) { ul.appendChild(i); });
    g.appendChild(ul);
    return g;
  }

  function settle(list) { // per-card failure isolation
    return Promise.all(list.map(function (p) { return p.then(function (v) { return v; }, function () { return null; }); }));
  }

  function render(urlFirst) {
    var token = ++renderToken;
    var v = currentVariant(urlFirst === true);
    if (!v) return collapse();
    getMap().then(function (map) {
      var src = map.sources && map.sources[handle];
      if (!src) return collapse();
      var jobs = function (list) {
        return settle(list.map(function (e) { return getProduct(e.handle).then(function (d) { var r = resolve(d, v.color, v.pack); return r ? { e: e, r: r } : null; }); }));
      };
      return Promise.all([jobs(src.A || []), jobs(src.B || [])]).then(function (res) {
        if (token !== renderToken) return; // superseded by a newer variant change
        var A = res[0].filter(Boolean).map(function (x) { return card(x.e, x.r, 'A'); });
        var B = res[1].filter(Boolean).slice(0, 2).map(function (x) { return card(x.e, x.r, 'B'); });
        while (groupsEl.firstChild) groupsEl.removeChild(groupsEl.firstChild);
        if (A.length) groupsEl.appendChild(group('More sizes in this finish', A));
        if (B.length) groupsEl.appendChild(group('Same size, other styles', B));
        if (!A.length && !B.length) return collapse();
        root.classList.remove('is-empty');
        root.classList.add('is-ready');
        observeImpressions();
      });
    }).catch(function () { if (token === renderToken) collapse(); });
  }

  function emit(name, payload) {
    if (!CW_XLINK_ANALYTICS) return;
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, payload); } catch (e) { /* no-op */ }
  }
  function observeImpressions() {
    if (!CW_XLINK_ANALYTICS || !('IntersectionObserver' in window)) return;
    root.querySelectorAll('.cw-xlink__group').forEach(function (g, i) {
      var module = g.querySelector('[data-cw-module]') ? g.querySelector('[data-cw-module]').getAttribute('data-cw-module') : String(i);
      if (seen[module]) return;
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio >= 0.5 && !seen[module]) { seen[module] = true; emit('cw_crosslink_impression', { module: module, source: handle }); io.disconnect(); } });
      }, { threshold: 0.5 });
      io.observe(g);
    });
  }

  var debounce = null;
  function schedule() { clearTimeout(debounce); debounce = setTimeout(function () { render(false); }, 150); }
  function scheduleFromUrl() { clearTimeout(debounce); debounce = setTimeout(function () { render(true); }, 150); }

  function start() {
    var sec = mainSection();
    var picker = sec ? sec.querySelector('variant-radios, variant-selects') : null;
    if (picker) picker.addEventListener('change', schedule);
    window.addEventListener('popstate', scheduleFromUrl);
    render();
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (ents) { if (ents.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '600px 0px' });
    io.observe(root);
  } else {
    start();
  }
})();
